var map = {
	"./": "./node_modules/raw-loader/dist/cjs.js!./src/files/index.js",
	"./algorithm-visualizer/README.md": "./node_modules/raw-loader/dist/cjs.js!./README.md",
	"./index": "./node_modules/raw-loader/dist/cjs.js!./src/files/index.js",
	"./index.js": "./node_modules/raw-loader/dist/cjs.js!./src/files/index.js",
	"./scratch-paper/README.md": "./node_modules/raw-loader/dist/cjs.js!./src/files/scratch-paper/README.md",
	"./skeletons/code": "./node_modules/raw-loader/dist/cjs.js!./src/files/skeletons/code.js",
	"./skeletons/code.cpp": "./node_modules/raw-loader/dist/cjs.js!./src/files/skeletons/code.cpp",
	"./skeletons/code.java": "./node_modules/raw-loader/dist/cjs.js!./src/files/skeletons/code.java",
	"./skeletons/code.js": "./node_modules/raw-loader/dist/cjs.js!./src/files/skeletons/code.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/files sync recursive ./!./node_modules/raw-loader/dist/cjs.js!./ ^\\.\\/.*$";